import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaStethoscope,
  FaHeartbeat,
  FaUserMd,
  FaMobileAlt,
  FaShieldAlt,
  FaArrowLeft,
  FaSearch,
} from "react-icons/fa";
import { ROUTES } from "../../constants/routes";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import DownloadModal from "../../components/DownloadModal/DownloadModal";
import styles from "./NotFound.module.css";

const NotFoundPage: React.FC = () => {
  const [animationClass, setAnimationClass] = useState("");
  const [floatingIcons] = useState([
    { icon: FaStethoscope, delay: 0, x: 10, y: 20 },
    { icon: FaHeartbeat, delay: 1, x: 80, y: 30 },
    { icon: FaUserMd, delay: 2, x: 20, y: 70 },
    { icon: FaMobileAlt, delay: 3, x: 85, y: 80 },
    { icon: FaShieldAlt, delay: 4, x: 50, y: 15 },
  ]);

  useEffect(() => {
    setTimeout(() => setAnimationClass(styles.animate), 100);
  }, []);

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = ROUTES.HOME.path;
    }
  };

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <div className={`${styles.notFoundPage} ${animationClass}`}>
        <div className={styles.notFoundGradient}>
          {/* Floating Medical Icons */}
          <div className={styles.floatingIcons}>
            {floatingIcons.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div
                  key={index}
                  className={styles.floatingIcon}
                  style={{
                    left: `${item.x}%`,
                    top: `${item.y}%`,
                    animationDelay: `${item.delay}s`,
                  }}
                >
                  <IconComponent />
                </div>
              );
            })}
          </div>

          <div className={styles.container}>
            <div className={styles.notFoundContent}>
              {/* Animated 404 Number with Medical Cross */}
              <div className={styles.errorNumber}>
                <span className={styles.number4}>4</span>
                <div className={styles.medicalCross}>
                  <div className={styles.crossVertical}></div>
                  <div className={styles.crossHorizontal}></div>
                  <FaHeartbeat className={styles.crossHeart} />
                </div>
                <span className={styles.number4End}>4</span>
              </div>

              {/* Error Message */}
              <div className={styles.errorMessage}>
                <h1 className={styles.errorTitle}>
                  <FaSearch className={styles.titleIcon} />
                  Page Not Found
                </h1>
                <p className={styles.errorDescription}>
                  Oops! The page you're looking for seems to have gone for a
                  medical checkup. Let's get you back to health and wellness!
                </p>
              </div>

              {/* Action Buttons */}
              <div className={styles.errorActions}>
                <button
                  onClick={handleGoBack}
                  className={`${styles.btn} ${styles.btnPrimary}`}
                >
                  <FaArrowLeft className={styles.btnIcon} />
                  Go Back
                </button>
                <Link
                  to={ROUTES.HOME.path}
                  className={`${styles.btn} ${styles.btnSecondary}`}
                >
                  <FaHome className={styles.btnIcon} />
                  Go Home
                </Link>
              </div>

              {/* App Download CTA */}
              <div className={styles.appCta}>
                <div className={styles.appCtaContent}>
                  <h3>Download LicoMeds App</h3>
                  <p>Access healthcare with cashback rewards</p>
                  <DownloadModal
                    variant="button"
                    className={`${styles.btn} ${styles.btnSuccess}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NotFoundPage;
